import type { DataProxy } from "@apollo/client";
import AssetDiscussionCommentWithRepliesCountFields from "lib/graphql/fragments/AssetDiscussionCommentWithRepliesCountFields";
import type { IAssetDiscussionCommentWithRepliesCountFieldsFragment } from "lib/graphql/fragments/__generated__/AssetDiscussionCommentWithRepliesCountFields.generated";

export default function transformOnAssetDiscussionCommentWithRepliesCountFields(
  dataProxy: DataProxy,
  rootCommentId: string,
  transform: (
    fragmentData: IAssetDiscussionCommentWithRepliesCountFieldsFragment,
  ) => IAssetDiscussionCommentWithRepliesCountFieldsFragment,
) {
  try {
    const fragmentID = `AssetDiscussionComment:${rootCommentId}`;
    const fragmentData = dataProxy.readFragment<IAssetDiscussionCommentWithRepliesCountFieldsFragment>({
      fragment: AssetDiscussionCommentWithRepliesCountFields,
      fragmentName: "AssetDiscussionCommentWithRepliesCountFields",
      id: fragmentID,
      variables: undefined,
    });

    if (!fragmentData) {
      return;
    }

    dataProxy.writeFragment<IAssetDiscussionCommentWithRepliesCountFieldsFragment>({
      fragment: AssetDiscussionCommentWithRepliesCountFields,
      fragmentName: "AssetDiscussionCommentWithRepliesCountFields",
      id: fragmentID,
      variables: undefined,
      data: transform(fragmentData),
    });
  } catch (err) {} // eslint-disable-line
}
